import { render, staticRenderFns } from "./InnovationPage.vue?vue&type=template&id=10f693ed&scoped=true&"
import script from "./InnovationPage.vue?vue&type=script&lang=js&"
export * from "./InnovationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f693ed",
  null
  
)

export default component.exports